export type WorkType = "movie" | "tv" | "variety";

export interface Work {
  id: string;
  title: string;
  enTitle: string;
  type: WorkType;
  genre: string[];
  region: string;
  year: number;
  rating: number;
  cover: string;
  poster: string;
  summary: string;
  director: string;
  cast: string[];
  duration: string;
  updateTime: string;
  views: number;
  featured: boolean;
}

export interface NewsItem {
  id: string;
  title: string;
  category: string;
  source: string;
  publishTime: string;
  cover: string;
  lead: string;
  content: string[];
}

export interface Collection {
  id: string;
  title: string;
  subtitle: string;
  desc: string;
  cover: string;
  workIds: string[];
}

export const workTypeLabel: Record<WorkType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};